import React from "react";
import { Form, Input } from "antd";
import Flex from "./Flex";
import Typographys from "./Typographys"; // Assuming Typographys is defined somewhere
import { TYPOGRAPHY } from "../../constants"; // Assuming TYPOGRAPHY is a constant
import { useThemeContext } from "../../theme/GlobalTheme";

/**
 * Textarea Component
 *
 * This component wraps an Ant Design Input.TextArea within a Form.Item.
 * It includes customizable labels and error indication based on the form item props.
 *
 * @param {Object} formItemProps - Props for the Form.Item component (e.g., label, name, required).
 * @param {Object} textareaProps - Props for the Input.TextArea component.
 * @param {function} onChange - Handler function for the textarea's change event.
 */
function Textarea({ formItemProps = {}, textareaProps = {}, onChange, value }) {
  const { isDark } = useThemeContext();
  const { label, required } = formItemProps; // Destructuring formItemProps
  return (
    <Form.Item {...formItemProps}>
      <Flex gap={4} vertical>
        <Flex gap={4}>
          {/* Display label if provided */}
          {label && <Typographys text={label} type={TYPOGRAPHY.PARA} />}
          {/* Display '*' if field is required */}
          {required && (
            <Typographys
              className="!pt-1 !text-[#FF0000]"
              text="*"
              type="para"
            />
          )}
        </Flex>
        {/* Input.TextArea with size large and onChange handler */}
        <Input.TextArea
          size="large"
          className={` text-[14px] md:text-[18px] !font-normal bg-[#f2f2f3] hover:bg-gray-100 border-[#e3e3e7] hover:border-[#e3e3e7] focus:border-[#e3e3e7] ${
            isDark
              ? " focus:bg-purple-950 bg-purple-900 hover:bg-purple-900 "
              : " focus:bg-teal-100"
          }`}
          {...textareaProps} // Spread additional textarea props
          onChange={onChange}
          value={value}
        />
      </Flex>
    </Form.Item>
  );
}

export default Textarea;
